<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>、
        <el-breadcrumb-item>中文官网</el-breadcrumb-item>
        <el-breadcrumb-item>职位管理</el-breadcrumb-item>
        <el-breadcrumb-item>职位设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="handleAdd">添加</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="sort"
            width="100"
            label="排序">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.sort" @change="changeSort(scope.row)" :min="0"
                        :max="250"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="140"
            prop="name"
            label="职位名称">
          </el-table-column>
          <el-table-column
            align="center"
            width="120"
            prop="position.name"
            label="职位类型">
          </el-table-column>
          <el-table-column
            align="center"
            width="150"
            prop="cities"
            label="工作地点">
            <template slot-scope="scope">
              <span v-for="city in scope.row.cities" :key="city.id">
                {{city.name}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="responsibility"
            label="岗位职责">
            <template slot-scope="scope">
              <el-input type="textarea"  v-model="scope.row.responsibility" @change="handleChange(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="requirement"
            label="岗位要求">
            <template slot-scope="scope">
              <el-input type="textarea"  v-model="scope.row.requirement" @change="handleChange(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="100"
            prop="status"
            label="显示状态">
            <template slot-scope="scope">
              <el-switch
                v-model.number="scope.row.status"
                active-color="#13ce66"
                @change="toggleStatus(scope.row.id)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="180">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="edit(scope.row)">编辑
              </el-button>
              <el-popconfirm
                v-show="scope.row.id !== 1000"
                confirmButtonText='确认'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @current-change="handlePageChange"
            :current-page=current_page
            :page-size=page_size
            :total=total
            layout="total, prev, pager, next,jumper"
          >
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false"  width="600px" class="padding_10">
      <el-form :model="form" label-width="120px" :rules="storeRoleRules" ref="addForm">
        <el-form-item label="职位名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="职位类型" prop="job_position_id">
          <el-select v-model="form.job_position_id" placeholder="请选择职位类型" style="width: 100%">
            <el-option v-for="type in jobPositions" :label="type.name" :value="type.id" :key="type.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="工作地点" prop="cities">
          <el-select multiple v-model="form.cities" placeholder="请选择工作地点" style="width: 100%">
            <el-option v-for="item in cities" :label="item.name" :value="item.id" :key="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="工作职责" prop="responsibility">
          <el-input type="textarea" v-model="form.responsibility"></el-input>
        </el-form-item>
        <el-form-item label="岗位要求" prop="requirement">
          <el-input type="textarea" v-model="form.requirement"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="submit()">确 定</el-button>
        <el-button @click="dialogVisible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss">

</style>

<script>
import {addJob, updateJob, getJobList, toggleStatus, setSort, delJob} from '../../api/job'
import {getJobPositionList} from '../../api/jobPosition'
import {getCityList} from '../../api/city'

export default {
  data () {
    return {
      form: {
        id: '',
        name: '',
        cities: [],
        requirement: '',
        responsibility: '',
        job_position_id: ''
      },
      loading: false,
      cities: [],
      total: 0,
      tableData: [],
      made: 'create',
      page_size: 50,
      jobPositions: [],
      current_page: 1,
      dialogVisible: false,
      storeRoleRules: {
        name: [
          {required: true, message: '请输入工作地点', trigger: 'blur'}
        ],
        job_position_id: [
          {required: true, message: '请选择岗位类型', trigger: 'blur'}
        ],
        cities: [
          {required: true, message: '请选择工作地点', trigger: 'blur'}
        ],
        responsibility: [
          {required: true, message: '请输入工作职责', trigger: 'blur'}
        ],
        requirement: [
          {required: true, message: '请输入岗位要求', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.loadJobs()

    getJobPositionList().then(response => {
      this.jobPositions = response.data.table_list
    })

    getCityList().then(response => {
      this.cities = response.data.table_list
    })
  },
  methods: {
    handlePageChange (page) {
      this.loadJobs({page: page})
    },
    handleChange (item) {
      this.form.id = item.id
      this.form.name = item.name
      this.form.job_position_id = item.job_position_id
      this.form.responsibility = item.responsibility
      this.form.requirement = item.requirement
      let cities = []
      item.cities.forEach(location => {
        cities.push(Number(location.id))
      })
      this.form.cities = cities
      this.update()
      this.loadJobs({page: 1})
    },
    toggleStatus (id) {
      toggleStatus(id).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    changeSort (item) {
      if (!(/^[0-9]*$/.test(item.sort))) {
        return this.$notify({
          message: '只能输入数字',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      let input = {id: item.id, sort: item.sort}
      setSort(input).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    handleAdd () {
      this.made = 'create'
      this.dialogVisible = true
      Object.keys(this.form).map(key => {
        this.form[key] = ''
      })
    },
    submit () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (this.made === 'create') {
            this.add()
          } else {
            this.update()
          }
        } else {
          return false
        }
      })
    },
    add () {
      this.loading = true
      addJob(this.form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.dialogVisible = false
          this.loadJobs()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    update () {
      this.loading = true
      updateJob(this.form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.dialogVisible = false
          this.loadJobs()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    edit (item) {
      this.made = 'edit'
      this.form.id = item.id
      this.form.name = item.name
      this.form.job_position_id = item.job_position_id
      this.form.responsibility = item.responsibility
      this.form.requirement = item.requirement
      let cities = []
      item.cities.forEach(location => {
        cities.push(Number(location.id))
      })
      this.form.cities = cities
      this.dialogVisible = true
    },
    del (id) {
      delJob(id).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.loadJobs()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    loadJobs (params) {
      getJobList(params).then(response => {
        let tableList = response.data.table_list
        this.total = tableList.total
        this.tableData = tableList.data
        this.page_size = tableList.per_page
        this.current_page = tableList.current_page
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/job/index.vue